<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :actions="false"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Banco beneficiario ACH', column: 'bancobeneficiarioach'},
            {label: 'Banco beneficiario ciudad WIRE', column: 'bancobeneficiariociudadwire'},
            {label: 'Banco beneficiario dirección WIRE', column: 'bancobeneficiariodireccionwire'},
            {label: 'Banco beneficiario país WIRE', column: 'bancobeneficiariopaiswire'},
            {label: 'Banco beneficiario WIRE', column: 'bancobeneficiariowire'},
            {label: 'Banco intermediario ciudad WIRE', column: 'bancointerciudadwire'},
            {label: 'Banco intermediario dirección WIRE', column: 'bancointerdireccionwire'},
            {label: 'Banco intermediario ACH', column: 'bancointermediarioach'},
            {label: 'Banco intermediario WIRE', column: 'bancointermediariowire'},
            {label: 'Banco intermediario pais WIRE', column: 'bancointerpaiswire'},
            {label: 'Código banco beneficiario', column: 'codigobancobeneficiario'},
            {label: 'Código banco intermediario', column: 'codigobancointermediario'},
            {label: 'Código instrucción 1', column: 'codigoinstruccion1'},
            {label: 'Código instrucción 2', column: 'codigoinstruccion2'},
            {label: 'Código instrucción 3', column: 'codigoinstruccion3'},
            {label: 'Código instrucción 4', column: 'codigoinstruccion4'},
            {label: 'Descripción banco beneficiario', column: 'descripcionbancobeneficiario'},
            {label: 'Estado', column: 'status'},
            {label: 'Número de cuenta beneficiaria', column: 'numerocuentabenef'},
            {label: 'Principal', column: 'principal'},
            {label: 'Texto instrucción 1', column: 'textoinstruccion1'},
            {label: 'Texto instrucción 2', column: 'textoinstruccion2'},
            {label: 'Texto instrucción 3', column: 'textoinstruccion3'},
            {label: 'Texto instrucción 4', column: 'textoinstruccion4'},
            {label: 'Tiene pago dólares', column: 'tienepagod'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Fecha de creación', column: 'created_on'},
            {label: 'Histórico generado por', column: 'modified_by_hist'},
            {label: 'Fecha creación del histórico', column: 'modified_on_hist'}
          ],
          endpoint: 'emp_bank_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Número de cuenta', dataIndex: 'bank_account', sorter: true},
              {title: 'Tipo de cuenta', dataIndex: 'bank_type', sorter: true},
              {title: 'Nombre del banco', dataIndex: 'nombre_banco', sorter: true},
              {title: 'Banco intermedio', dataIndex: 'banco_interm', sorter: true},
              {title: 'Banco beneficiario', dataIndex: 'banco_benefi', sorter: true},
              {title: 'Sitio del banco', dataIndex: 'bank_office', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    methods: {
      consultarDatos () {
        this.$refs.master.$refs.datatable.loadData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeBankHist.vue